export default __webpack_public_path__ + "assets/img/line-awesome.3400fa38b566632e63a76d3b766689ee.eot";